// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"650":"77c2dcd0","1865":"77c2dcd0","2529":"77c2dcd0","4667":"77c2dcd0","8585":"24b05fda","8672":"77c2dcd0"}[chunkId] + ".chunk.css";
};